import {
  AfterViewInit,
  Component,
  ElementRef,
  HostBinding,
  Input,
  NgZone,
  OnDestroy,
  OnInit
} from "@angular/core";
import { PermissionsService } from "../../routes/services/permissions.service";

/* Ancho del contenedor (no de la ventana) por debajo del cual las filas se apilan */
const NARROW_WIDTH = 576;

@Component({
  selector: "app-config-sensors-device",
  templateUrl: "./config_sensor_device.html",
  styleUrls: ["./config_sensor_device.scss"]
})
export class ConfigSensorDeviceComponent implements OnInit, AfterViewInit, OnDestroy {
  @Input() config_mode: "min-max" | "automatic" | "fuzzy-logic" = "min-max";
  @Input() type: "client" | "feeder" | "waterwise" | "farm" | "pond" = "feeder";
  @Input() pond_id: number | "" = "";

  @Input() id: number | "" = "";
  @Input() buttons_header: boolean = true;
  @Input() massiveUpdate = false;
  @Input() selectedItems = [];
  @Input() region_id: null | number = null;
  @Input() viewNotifications: boolean = false;
  permissions = {
    change_parametricpreference: true
  };

  /*
   * El componente se muestra en contenedores muy distintos (offsidebar, modales
   * de varios tamanos), asi que el acomodo depende del ancho del propio
   * componente. Los hijos lo leen con :host-context(.cfg-narrow).
   */
  @HostBinding("class.cfg-narrow") isNarrow = false;

  // ResizeObserver no esta en los tipos DOM de TypeScript 4.0
  private resizeObserver: any = null;

  constructor(
    public permissionsService: PermissionsService,
    private elementRef: ElementRef<HTMLElement>,
    private ngZone: NgZone
  ) {}

  /** Calcula los permisos del usuario sobre las preferencias parametricas. */
  ngOnInit(): void {
    const validate_permissions = () => {
      const validate_subclient = (prop: string) => {
        return this.permissionsService.validatePermissionsExistSubclient(prop);
      };
      this.permissions = {
        change_parametricpreference: validate_subclient("change_parametricpreference")
      };
    };
    validate_permissions();
  }

  /** Observa el ancho del componente para alternar entre filas y acomodo apilado. */
  ngAfterViewInit(): void {
    const host = this.elementRef.nativeElement;
    const ResizeObserverCtor = (window as any).ResizeObserver;
    if (!ResizeObserverCtor) {
      // Sin ResizeObserver solo se mide una vez, despues de la primera deteccion de cambios
      setTimeout(() => this.updateNarrow(host.clientWidth));
      return;
    }
    // ResizeObserver avisa el tamano inicial al empezar a observar.
    // Fuera de la zona de Angular: solo se vuelve a entrar cuando cambia el acomodo
    this.ngZone.runOutsideAngular(() => {
      this.resizeObserver = new ResizeObserverCtor((entries: any[]) => {
        const width = entries[0] ? entries[0].contentRect.width : host.clientWidth;
        this.updateNarrow(width);
      });
      this.resizeObserver.observe(host);
    });
  }

  /** Deja de observar el tamano del componente. */
  ngOnDestroy(): void {
    if (this.resizeObserver) {
      this.resizeObserver.disconnect();
      this.resizeObserver = null;
    }
  }

  /**
   * Actualiza el acomodo segun el ancho disponible. Un ancho 0 (contenedor oculto)
   * se ignora para no cambiar el acomodo mientras no se ve.
   * @param width Ancho del componente en px CSS.
   */
  private updateNarrow(width: number): void {
    if (!width) {
      return;
    }
    const narrow = width < NARROW_WIDTH;
    if (narrow !== this.isNarrow) {
      this.ngZone.run(() => (this.isNarrow = narrow));
    }
  }
}
